var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYellowWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 39,
    viewBox: "0 0 43 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3516 2.856C18.4936 -0.952 23.9732 -0.952 26.1124 2.856L41.7364 30.632C43.8364 34.3672 41.14 38.976 36.8588 38.976H5.608C1.324 38.976 -1.3724 34.3672 0.727597 30.632L16.3516 2.856ZM24.032 30.5788C24.032 31.3214 23.737 32.0336 23.2119 32.5587C22.6868 33.0838 21.9746 33.3788 21.232 33.3788C20.4894 33.3788 19.7772 33.0838 19.2521 32.5587C18.727 32.0336 18.432 31.3214 18.432 30.5788C18.432 29.8362 18.727 29.124 19.2521 28.5989C19.7772 28.0738 20.4894 27.7788 21.232 27.7788C21.9746 27.7788 22.6868 28.0738 23.2119 28.5989C23.737 29.124 24.032 29.8362 24.032 30.5788V30.5788ZM21.232 8.1788C20.4894 8.1788 19.7772 8.4738 19.2521 8.9989C18.727 9.524 18.432 10.2362 18.432 10.9788V19.3788C18.432 20.1214 18.727 20.8336 19.2521 21.3587C19.7772 21.8838 20.4894 22.1788 21.232 22.1788C21.9746 22.1788 22.6868 21.8838 23.2119 21.3587C23.737 20.8336 24.032 20.1214 24.032 19.3788V10.9788C24.032 10.2362 23.737 9.524 23.2119 8.9989C22.6868 8.4738 21.9746 8.1788 21.232 8.1788Z",
    fill: "#E6B407"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowWarning);
export default __webpack_public_path__ + "static/media/YellowWarning.70b69a8196d13cfd889b09d4e9e9c4b6.svg";
export { ForwardRef as ReactComponent };